import { Badge } from '../ui/badge';
import {
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    useSidebar,
} from '../ui/sidebar';
import { Link, useLocation } from 'react-router-dom';

export function NavMain({ items, header }) {
    const location = useLocation();
    const activePage = location.pathname;
    const { isMobile, setOpenMobile } = useSidebar();

    const handleMobileNavClose = () => {
        if (isMobile) {
            setOpenMobile(false);
        }
    };

    // Longest-prefix-wins active matching.
    // Without this, /leads/pre-qualification highlights BOTH "Leads" (/leads)
    // and "Pre-qual Form" (/leads/pre-qualification) because /leads is a
    // prefix of the sub-route. We pick the most specific match per group.
    const activeItemUrl = items.reduce((bestUrl, item) => {
        const url = item.url;
        if (!url) return bestUrl;
        const matches =
            activePage === url ||
            (url !== '/' && activePage.startsWith(url.endsWith('/') ? url : `${url}/`));
        if (!matches) return bestUrl;
        if (bestUrl === null || url.length > bestUrl.length) return url;
        return bestUrl;
    }, null);

    return (
        <SidebarGroup>
            {header && <SidebarGroupLabel>{header}</SidebarGroupLabel>}
            <SidebarGroupContent className="tw-flex tw-flex-col tw-gap-2">
                <SidebarMenu>
                    {items.map((item) => {
                        const isActive = activeItemUrl === item.url;
                        return (
                            <SidebarMenuItem key={item.title}>
                                <Link to={item.url} onClick={handleMobileNavClose}>
                                    <SidebarMenuButton
                                        className={
                                            isActive
                                                ? 'tw-min-w-8 tw-bg-primary-theme tw-text-primary-theme-foreground tw-duration-200 tw-ease-linear hover:!tw-bg-primary-theme/90 hover:!tw-text-primary-theme-foreground active:tw-bg-primary-theme/90 active:tw-text-primary-theme-foreground'
                                                : ''
                                        }
                                        tooltip={item.title}
                                    >
                                        <>
                                            {item.icon && <item.icon />}
                                            <span>{item.title}</span>
                                            {item?.badge ? (
                                                <Badge
                                                    variant="secondary"
                                                    className="tw-ml-auto !tw-rounded-full tw-text-xs"
                                                >
                                                    {item?.badge}
                                                </Badge>
                                            ) : (
                                                <></>
                                            )}
                                        </>
                                    </SidebarMenuButton>
                                </Link>
                            </SidebarMenuItem>
                        );
                    })}
                </SidebarMenu>
            </SidebarGroupContent>
        </SidebarGroup>
    );
}
